import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Button, { Colors } from '../../atoms/Button';
import ConfirmationDialogView from './ConfirmationDialogView';

function ConfirmationDialog({
  dialogRef,
  open = false,
  message = '',
  onCancel = () => { },
  onConfirm = () => { },
  confirmText,
  confirmColor = Colors.Success,
  cancelText = 'Cancel',
}) {
  // --- State hooks ---
  const defaultRef = useRef(null);

  // Use the passed dialogRef or fall back to our default ref
  const finalRef = dialogRef || defaultRef;

  return ReactDOM.createPortal(
    <ConfirmationDialogView
      dialogRef={finalRef}
      open={open}
      message={message}
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmText={confirmText}
      confirmColor={confirmColor}
      cancelText={cancelText}
    />,
    document.getElementById('portal-root'),
  );
}

ConfirmationDialog.propTypes = {
  dialogRef: PropTypes.object,
  open: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  confirmText: PropTypes.string,
  confirmColor: PropTypes.oneOf(Object.values(Colors)),
  cancelText: PropTypes.string,
};

export default ConfirmationDialog;
